
import React from "react";
import { TickerContent } from "./TickerContent";

interface BottomTickerProps {
  messages: string[];
  textColor: string;
  speed?: number;
}

export const BottomTicker = React.memo(({ messages, textColor, speed = 20 }: BottomTickerProps) => {
  console.log('BottomTicker speed:', speed);
  return (
    <div className="h-[38px] pt-2">
      <TickerContent messages={messages} textColor={textColor} speed={speed} />
    </div>
  );
});

BottomTicker.displayName = 'BottomTicker';
